module.exports = __webpack_public_path__ + "static/media/file_type_pdf.d7af3ce6.svg";